import {AvailablePropertyType} from '../enum/available-property.type';

export class PropertyRequest {
  constructor(
    public readonly type: AvailablePropertyType,
    public readonly value: string | number | boolean | null
  ) {
  }
}
